module.exports = __webpack_public_path__ + "img/bottomImg2.84938a98.png";